module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_okunai_tvb-7a3afa3dcb469f98a2db87dcde686e97.jpg";